import { Outlet } from 'react-router-dom';

export default function Jobs() {
    return (<Outlet />)
};
